module.exports = __webpack_public_path__ + "img/rancher-logo.698ff972.svg";